<template>
  <b-card-code title="Hasil Sidang">
    <!-- Tabs with card integration -->
    <b-tabs v-model="tabIndex">
      <b-tab
        title="Catatan"
        v-if="mainData.is_penguji == true && mainData.catatan_dosen == true"
      >
        <div class="mt-5 mb-5">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('Judul')"></label>
                <b-form-textarea
                  id="judul"
                  rows="3"
                  placeholder="Judul"
                  v-model="catatan.judul"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('Abstrak')"></label>
                <b-form-textarea
                  id="abstrak"
                  rows="3"
                  placeholder="Abstrak"
                  v-model="catatan.abstrak"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('BAB I')"></label>
                <b-form-textarea
                  id="bab_1"
                  rows="3"
                  placeholder="BAB I"
                  v-model="catatan.bab_1"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('BAB II')"></label>
                <b-form-textarea
                  id="BAB II"
                  rows="3"
                  placeholder="BAB II"
                  v-model="catatan.bab_2"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('BAB III')"></label>
                <b-form-textarea
                  id="BAB III"
                  rows="3"
                  placeholder="BAB III"
                  v-model="catatan.bab_3"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('BAB IV')"></label>
                <b-form-textarea
                  id="BAB IV"
                  rows="3"
                  placeholder="BAB IV"
                  v-model="catatan.bab_4"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('BAB V')"></label>
                <b-form-textarea
                  id="BAB V"
                  rows="3"
                  placeholder="BAB V"
                  v-model="catatan.bab_5"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('Kepustakaan')"></label>
                <b-form-textarea
                  id="Kepustakaan"
                  rows="3"
                  placeholder="Kepustakaan"
                  v-model="catatan.kepustakaan"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label v-html="formatLabel('Lainnya')"></label>
                <b-form-textarea
                  id="Lainnya"
                  rows="3"
                  placeholder="Lainnya"
                  v-model="catatan.lainnya"
                  @input="(val) => simpanDataCatatan('onchange')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-1 mr-1"
                  @click="simpanDataCatatan"
                >
                  Simpan
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Penilaian" v-if="mainData.is_penguji == true">
        <div class="mt-5 mb-5">
          <!-- <b-alert show variant="danger" class="text-center" style="height: auto; padding:15px;" v-if="mainData.catatan_perubahan_nilai.catatan != null">{{mainData.catatan_perubahan_nilai.catatan}}</b-alert> -->
          <div class="mb-3" v-for="item in mainData.pertanyaan" :key="item.id">
            <div class="d-flex">
              <h5 class="mb-3 mr-3">{{ item.group }}</h5>
              <h5 class="mr-3">Nilai Rata-Rata : {{ item.nilai_rata_rata }}</h5>
              <h5>Bobot : {{ item.bobot }}</h5>
            </div>
            <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
              <b-col cols="6">
                <b-form-group>
                  <label v-html="formatLabel(pertanyaan.pertanyaan)"></label>
                  <b-form-input
                    :id="'p' + pertanyaan.id"
                    placeholder="Masukkan Nilai"
                    type="number"
                    v-model="pertanyaan.jawaban"
                    :disabled="mainData.status_pengajuan_sidang_id == 5"
                    @input="(val) => simpanDataJawabanRealtime('konfirmasi')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <b-col cols="12">
            <div class="d-flex justify-content-end">
              <b-button
                v-if="mainData.status_pengajuan_sidang_id != 5"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-1 mr-1"
                @click="simpanDataJawaban('konfirmasi')"
              >
                Simpan
              </b-button>
            </div>
          </b-col>
        </div>
      </b-tab>
      <b-tab
        title="Angket"
        v-if="mainData.is_penguji == false && mainData.jenjang_id == 1"
      >
        <div class="mt-5 mb-5">
          <form-wizard-angket />
        </div>
      </b-tab>
      <b-tab title="Catatan Revisi" v-if="mainData.is_penguji == false">
        <div class="mt-5 mb-5">
          <form-wizard :catatan_rev="mainData.catatan_revisi" />
        </div>
      </b-tab>
      <b-tab title="Daftar Hadir dan Berita Acara" v-if="mainData.is_pembimbing == true">
        <div class="mt-5 mb-5">
          <div class="d-flex" v-for="item in mainData.absensi.mahasiswa">
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Mahasiswa')"></label>
                <b-form-input :value="item.name" :disabled="true" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Absensi')"></label>
                <v-select
                  id="absensi"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="(val) => val.value"
                  :options="absensiOption.options"
                  v-model="item.is_absen"
                  placeholder="Pilih Absensi"
                />
              </b-form-group>
            </b-col>
          </div>
          <div class="d-flex" v-for="(item, index) in mainData.absensi.dospem">
            <b-col cols="6">
              <b-form-group>
                <label
                  v-html="
                    formatLabel(
                      item.pembimbing_utama == 1
                        ? 'Dosen Pembimbing ' + (index + 1) + ' (Utama)'
                        : 'Dosen Pembimbing ' + (index + 1)
                    )
                  "
                ></label>
                <b-form-input :value="item.nama" :disabled="true" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Absensi')"></label>
                <v-select
                  id="absensi"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="(val) => val.value"
                  :options="absensiOption.options"
                  v-model="item.is_absen"
                  placeholder="Pilih Absensi"
                />
              </b-form-group>
            </b-col>
          </div>
          <div class="d-flex" v-for="(item, index) in mainData.absensi.dosmik">
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Dosen Pembimbing Akademik')"></label>
                <b-form-input :value="item.nama" :disabled="true" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Absensi')"></label>
                <v-select
                  id="absensi"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="(val) => val.value"
                  :options="absensiOption.options"
                  v-model="item.is_absen"
                  placeholder="Pilih Absensi"
                />
              </b-form-group>
            </b-col>
          </div>
          <div class="d-flex" v-for="(item, index) in mainData.absensi.dosji">
            <b-col cols="6">
              <b-form-group>
                <label
                  v-html="
                    formatLabel(
                      item.penguji_utama == 1
                        ? 'Dosen Penguji ' + (index + 1) + ' (Utama)'
                        : 'Dosen Penguji ' + (index + 1)
                    )
                  "
                ></label>
                <b-form-input :value="item.nama" :disabled="true" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label v-html="formatLabel('Absensi')"></label>
                <v-select
                  id="absensi"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="(val) => val.value"
                  :options="absensiOption.options"
                  v-model="item.is_absen"
                  placeholder="Pilih Absensi"
                />
              </b-form-group>
            </b-col>
          </div>
          <b-col cols="12">
            <b-form-group>
              <label v-html="formatLabel('Berita Acara')"></label>
              <b-form-textarea
                id="berita_acara"
                placeholder="Berita Acara"
                v-model="mainData.absensi.berita_acara.berita_acara"
                rows="3"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="d-flex justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-1 mr-1"
                @click="simpanBeritaAcara('konfirmasi')"
              >
                Simpan
              </b-button>
            </div>
          </b-col>
        </div>
      </b-tab>
      <b-tab
        title="Nilai Akhir"
        v-if="
          $can('manage', 'all-content') ||
          mainData.is_pembimbing == true ||
          mainData.is_penguji == true
        "
      >
        <b-card class="border mb-0">
          <div>
            <h5 class="mb-3">Nilai Akhir Mahasiswa</h5>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Nama</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{ mainData.nama_mahasiswa }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">NPM</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{ mainData.npm }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Judul</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{ mainData.judul }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Keterangan Lulus/Tidak</h5>
              </b-col>
              <b-col cols="6">
                <v-select
                  v-if="mainData.status_hasil_sidang_id != '11db23af23esdda8d5be3ff21222'"
                  id="status_hasil_sidang"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="(val) => val.value"
                  :options="statusHasilSidangOption.options"
                  v-model="mainData.status_hasil_sidang_id"
                  placeholder="Pilih Status Hasil Sidang"
                  :disabled="
                    mainData.status_hasil_sidang_id == '11db23af23esdda8d5be3ff21222' ||
                    mainData.pembimbing_utama != 'ya'
                  "
                />
                <!-- && mainData.nilai_lengkap != 'ya' -->
                <b-button
                  v-if="mainData.status_hasil_sidang_id == '11db23af23esdda8d5be3ff21222'"
                  variant="success"
                  >Selesai</b-button
                >
              </b-col>
            </b-row>
            <b-row
              v-if="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e'"
            >
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Tanggal Sidang</h5>
              </b-col>
              <b-col cols="6">
                <b-form-datepicker
                  id="awal-datepicker"
                  v-model="mainData.tanggal_awal_revisi"
                  class="mb-2"
                  locale="ID"
                  :disabled="
                    mainData.is_pembimbing != true || mainData.is_pembimbing == false
                  "
                ></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row
              v-if="mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e'"
            >
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Tanggal Akhir Revisi</h5>
              </b-col>
              <b-col cols="6">
                <b-form-datepicker
                  id="akhir-datepicker"
                  v-model="mainData.tanggal_akhir_revisi"
                  class="mb-2"
                  locale="ID"
                  :disabled="
                    mainData.is_pembimbing != true || mainData.is_pembimbing == false
                  "
                ></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h5 class="mb-3 mr-3">Total Nilai Akhir</h5>
              </b-col>
              <b-col cols="6">
                <h5>{{ mainData.nilai_akhir_mahasiswa }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <!-- <b-button
                      v-if="mainData.is_pembimbing == true && mainData.status_pengajuan_sidang_id != 5"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="warning"
                      class="mr-1"
                      @click="permintaanPerubahanNilai('konfirmasi')"
                    >
                      Permintaan Perubahan Nilai
                    </b-button> -->
                  <b-button
                    v-if="
                      mainData.status_hasil_sidang_id != '11db23af23esdda8d5be3ff21222'
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-1"
                    @click="simpanStatusHasilSidang('konfirmasi')"
                    :disabled="mainData.pembimbing_utama != 'ya'"
                  >
                    <!-- || mainData.nilai_lengkap != 'ya' -->
                    Simpan
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
        <b-card class="border mb-0">
          <div v-for="item in mainData.dospem" :key="item.id">
            <h5 class="mb-3">{{ item.nama_dosen }} (Dosen Pembimbing)</h5>
            <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
              <b-col cols="6">
                <h5 class="mb-3 mr-3">{{ pertanyaan.group }}</h5>
              </b-col>
              <b-col cols="6">
                <h5>Nilai Rata-Rata : {{ pertanyaan.nilai_rata_rata }}</h5>
              </b-col>
            </b-row>
            <h5 class="mb-3">Nilai Akhir : {{ item.nilai_akhir }}</h5>
          </div>
        </b-card>
        <b-card class="border mb-0">
          <div class="mb-3" v-for="item in mainData.dospeng" :key="item.id">
            <h5 class="mb-3">{{ item.nama_dosen }} (Dosen Penguji)</h5>
            <b-row v-for="pertanyaan in item.pertanyaan" :key="pertanyaan.id">
              <b-col cols="6">
                <h5 class="mb-3 mr-3">{{ pertanyaan.group }}</h5>
              </b-col>
              <b-col cols="6">
                <h5>Nilai Rata-Rata : {{ pertanyaan.nilai_rata_rata }}</h5>
              </b-col>
            </b-row>
            <h5 class="mb-3">Nilai Akhir : {{ item.nilai_akhir }}</h5>
            <hr />
          </div>
        </b-card>
      </b-tab>

      <!-- Jika Lulus dengan revisi -->
      <b-tab
        :title="mainData.is_revisi == 1 ? 'Berkas Revisi' : 'Berkas Kelengkapan'"
        v-if="
          mainData.status_hasil_sidang_id == '9ce2774bb5413c2ae55cc590722d7ca1' ||
          mainData.status_hasil_sidang_id == 'bb9947512ad89679db5736f951c8359e' ||
          mainData.status_hasil_sidang_id == '11db23af23esdda8d5be3ff21222'
        "
      >
        <div class="mt-5 mb-5">
          <b-card class="border mb-0">
            <b-row v-for="item in mainData.berkas" :key="item.uuid">
              <b-col md="6" v-if="item.file_type == 'file_pdf'">
                <b-form-group :title="item.description">
                  <label
                    for=""
                    :style="mainData.is_reviewer == false ? '' : 'margin-left: 15px;'"
                  >
                    {{ item.title }} (Max : 10mb)
                    <span style="color: red; font-size: 16px">* </span>
                    <feather-icon icon="InfoIcon" />
                  </label>
                  <validation-provider #default="{ errors }" :name="item.title_slug">
                    <div class="d-flex">
                      <b-form-file
                        :ref="`fileInput${item.title_slug}`"
                        v-model="file[item.title_slug]"
                        accept="application/pdf"
                        :disabled="mainData.is_reviewer == true"
                        @input="handleFileInput($event, item.title_slug)"
                      />
                      <b-button
                        v-if="item.file != null"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        :class="
                          mainData.is_reviewer == false
                            ? 'mb-75 mr-75 ml-1'
                            : 'mb-75 mr-75 ml-1 btn-block'
                        "
                        @click="lihatFile(item.file)"
                      >
                        Lihat <feather-icon icon="FileIcon" />
                      </b-button>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6" v-if="item.file_type == 'file_img'">
                <!-- <b-form-group
                :title="item.description"
              >
                <label for="" :style="mainData.is_reviewer == false ? '' : 'margin-left: 15px;'">
                  {{ item.title }}
                  <span style="color: red; font-size: 16px;">* </span>
                  <feather-icon icon="InfoIcon"/>
                </label>
                <validation-provider
                  #default="{ errors }"
                  :name="item.title_slug"
                >
                <div class="d-flex">
                   <b-form-file
                    ref="file-input"
                    v-model="file[item.title_slug]"
                    accept="application/image"
                    :disabled="mainData.is_reviewer == true"
                  />
                  <b-button
                    v-if="item.file != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    :class="mainData.is_reviewer == false ? 'mb-75 mr-75 ml-1' : 'mb-75 mr-75 ml-1 btn-block'"
                    @click="lihatFile(item.file)"
                  >
                    Lihat <feather-icon icon="FileIcon" />
                  </b-button>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->
              </b-col>
              <b-col cols="6" v-if="item.file_type == 'text'">
                <b-form-group :title="item.description">
                  <label for="">
                    {{ item.title }}
                    <span style="color: red; font-size: 16px">* </span>
                    <feather-icon icon="InfoIcon" />
                  </label>
                  <b-form-input
                    :id="item.title_slug"
                    :placeholder="item.title"
                    v-model="item[item.title_slug]"
                    :disabled="mainData.is_reviewer == true"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <b-spinner
                    v-if="showLoading == 1"
                    class="mt-1 mr-1"
                    :variant="'dark'"
                  ></b-spinner>
                  <b-button
                    v-if="
                      mainData.is_penguji == false &&
                      !$can('manage', 'all-content') &&
                      mainData.status_hasil_sidang_id != '11db23af23esdda8d5be3ff21222'
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-1 mr-1"
                    @click="simpanBerkas('konfirmasi')"
                    :disabled="showLoading == 1"
                  >
                    Simpan
                  </b-button>
                  <!-- <b-button
                    v-if="mainData.status_hasil_sidang_id != '11db23af23esdda8d5be3ff21222' && (mainData.pembimbing_utama == 'ya') && mainData.tandai_selesai == 'ya'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-1 mr-1"
                    @click="tandaiSelesai('konfirmasi')"
                  >
                    Tandai Selesai
                  </b-button> -->
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-tab>
    </b-tabs>
    <div>
      <b-modal id="bv-modal-konfirmasi" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses penilaian ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="simpanDataJawaban('ya')"
            >Ya</b-button
          >
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-nilai-akhir" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses penilaian ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="simpanStatusHasilSidang('ya')"
            >Ya</b-button
          >
          <b-button
            variant="danger"
            @click="$bvModal.hide('bv-modal-konfirmasi-nilai-akhir')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-berkas" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block text-center mt-3">
          <h3>Apakah anda yakin ingin memperoses berkas ini?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="simpanBerkas('ya')"
            >Ya</b-button
          >
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-berkas')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-perubahan-nilai" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block mt-3">
          <h3 class="mb-3 text-center">
            Apakah anda yakin ingin mengirim permintaan perubahan nilai ini?
          </h3>
          <b-form-group
            :label="'Catatan perubahan nilai'"
            :label-for="'Catatan perubahan nilai'"
          >
            <b-form-textarea
              id="catatan_perubahan_nilai"
              placeholder="Catatan Perubahan Nilai"
              v-model="perubahan_nilai.catatan"
              rows="3"
            />
          </b-form-group>
          <b-form-group :label="'Dosen Penguji'" :label-for="'Dosen Penguji'">
            <v-select
              id="dosen"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :reduce="(val) => val.value"
              :options="dosenPengujiOption.options"
              v-model="perubahan_nilai.dosen_penguji_id"
              placeholder="Pilih Dosen Penguji"
            />
          </b-form-group>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="permintaanPerubahanNilai('ya')"
            >Ya</b-button
          >
          <b-button
            variant="danger"
            @click="$bvModal.hide('bv-modal-konfirmasi-perubahan-nilai')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-selesai" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block mt-3">
          <h3 class="mb-3 text-center">
            Apakah anda yakin ingin tandai selesai hasil sidang ini?
          </h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="tandaiSelesai('ya')"
            >Ya</b-button
          >
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-selesai')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="bv-modal-konfirmasi-berita" hide-footer>
        <template #modal-title> Konfirmasi </template>
        <div class="d-block mt-3">
          <h3 class="mb-3 text-center">Apakah anda yakin?</h3>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mr-1"
            style="width: 90px"
            variant="success"
            @click="simpanBeritaAcara('ya')"
            >Ya</b-button
          >
          <b-button variant="danger" @click="$bvModal.hide('bv-modal-konfirmasi-berita')"
            >Tidak</b-button
          >
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="modal-center-loading"
        centered
        title="Loading"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        v-if="showModal === 1"
      >
        <div class="d-flex justify-content-center mt-2">
          <b-spinner :variant="'dark'"></b-spinner>
        </div>
        <div class="d-flex justify-content-center mt-2">Loading....</div>
        <b-button class="mt-3" block @click="reload()" variant="primary"
          >Muat Ulang</b-button
        >
      </b-modal>
    </div>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import {
  BButtonGroup,
  BButton,
  BCard,
  BTab,
  BTabs,
  BCardText,
  BFormTextarea,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormFile,
  BAlert,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  getDetailHasilSidang,
  updateCatatanHasilSidang,
  updateJawabanPenilaianHasilSidang,
  getStatusHasilSidang,
  updateStatusHasilSidang,
  updateBerkasHasilSidang,
  uploadFileBerkasHasilSidang,
  downloadBerkasHasilSidang,
  postPermintaanPerubahanNilai,
  postTandaiSelesai,
  updateBeritaAcara,
  buildBeritaAcara,
  postNotifUpdateBerkas,
} from "@/connection-api/master";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormWizard from "@/views/pages/hasil-sidang/catatan-revisi/FormWizard.vue";
import FormWizardAngket from "@/views/pages/hasil-sidang/angket/FormWizard.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BCardCode,
    BButtonGroup,
    BButton,
    BCard,
    BTab,
    BTabs,
    BCardText,
    BFormTextarea,
    BRow,
    BCol,
    BFormGroup,
    FormWizard,
    BFormInput,
    vSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BAlert,
    BModal,
    BSpinner,
    FormWizardAngket,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showLoading: 0,
      berita_acara: {},
      showModal: 1,
      perubahan_nilai: {},
      file: {},
      tabIndex: 0,
      mainData: {},
      catatan: {},
      jawaban_penilaian: {},
      status_hasil_sidang: {},
      selesai: {},
      counterPayload: 0,
      successPayload: 0,
      // codeProgrammatically,
      statusHasilSidangOption: {
        selected: "id",
        options: [{ value: null, label: "--Pilih Status Hasil Sidang --" }],
      },
      dosenPengujiOption: {
        selected: "id",
        options: [{ value: null, label: "--Pilih Dosen Penguji --" }],
      },
      absensiOption: {
        selected: "id",
        options: [
          { value: null, label: "--Pilih Absensi --" },
          { value: "ya", label: "Hadir" },
          { value: "tidak", label: "Tidak Hadir" },
        ],
      },
    };
  },
  methods: {
    handleFileInput(event, titleSlug) {
      const file = event;
      if (file) {
        if (file.size > 10 * 1024 * 1024) {
          // 10MB in bytes
          alert("The file size exceeds the 10MB limit.");
          // Clear the file input by setting v-model to null
          this.$refs[`fileInput${titleSlug}`][0].reset();
        }
      }
    },
    validateFileSize(titleSlug) {
      const file = this.file[titleSlug];
      if (file && file.size > 10 * 1024 * 1024) {
        // 10MB in bytes
        alert("The file size exceeds the 10MB limit. The file will be removed.");
        this.$set(this.file, titleSlug, null); // Remove the file and force reactivity update
      }
    },
    formatLabel(text) {
      return `${text} <span class="text-danger">*</span>`;
    },
    completeCheck(success_check) {
      if (success_check.length > 0) {
        this.showModal = 0;
      }
    },
    reload() {
      window.location.reload();
    },
    // simpanBerkas(params) {
    //   var marking = null;
    //   if(params == 'konfirmasi')
    //   {
    //     this.$bvModal.show('modal-center-loading')
    //     this.showModal = 1
    //     this.$bvModal.show('bv-modal-konfirmasi-berkas')
    //   } else if (params == 'ya'){
    //     this.$bvModal.show('modal-center-loading')
    //     this.showModal = 1
    //     this.mainData.berkas.forEach(item => {
    //       this.showLoading = 1
    //       if(item.file_type == 'text')
    //       {
    //         item.hasil_sidang_uuid = this.$route.params.uuid
    //         updateBerkasHasilSidang(item)
    //         .then(response => {
    //           if (response.data.success == true) {
    //             this.showLoading = 0
    //             // this.$toast({
    //             //   component: ToastificationContent,
    //             //   props: {
    //             //     title: 'Hasil Sidang',
    //             //     icon: 'EditIcon',
    //             //     variant: 'success',
    //             //     text: 'Data berhasil disimpan.',
    //             //   },
    //             // })
    //           }
    //         })
    //         .catch(error => {
    //         });
    //       }
    //       if(item.file_type == 'file_pdf' || item.file_type == 'file_img')
    //       {
    //         if(this.file[item.title_slug] != null)
    //         {
    //           uploadFileBerkasHasilSidang(this.file[item.title_slug], 'user', event => {
    //             this.progress = Math.round((100 * event.loaded) / event.total)
    //           })
    //           .then(response => {
    //             if (response.data.success == true) {
    //               this.showLoading = 0
    //               item.hasil_sidang_uuid = this.$route.params.uuid
    //               item.file_id = response.data.data.id
    //               updateBerkasHasilSidang(item)
    //               .then(response => {
    //                 if (response.data.success == true) {
    //                   //write your code
    //                 }
    //               })
    //               .catch(error => {
    //               });
    //             }
    //           })
    //           .catch(error => {
    //           });
    //         }
    //       }
    //     });
    //     setTimeout(() => {
    //       var data = {
    //         hasil_sidang_uuid: this.$route.params.uuid
    //       }
    //       this.showLoading = 1
    //       postNotifUpdateBerkas(data)
    //         .then(response => {
    //           this.showLoading = 0
    //           this.$toast({
    //             component: ToastificationContent,
    //             props: {
    //               title: 'Hasil Sidang',
    //               icon: 'EditIcon',
    //               variant: 'success',
    //               text: 'Data berhasil disimpan.',
    //             },
    //           })
    //           window.location.reload();
    //         })
    //         .catch(error => {
    //           this.showLoading = 0
    //         });
    //     }, 5000);
    //     this.showModal = 0
    //     this.$bvModal.hide('bv-modal-konfirmasi-berkas')
    //   }
    // },
    simpanBerkas(params) {
      var marking = null;
      if (params == "konfirmasi") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        this.$bvModal.show("bv-modal-konfirmasi-berkas");
      } else if (params == "ya") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        let promises = [];

        this.mainData.berkas.forEach((item) => {
          if (item.file_type == "text") {
            item.hasil_sidang_uuid = this.$route.params.uuid;
            let updatePromise = updateBerkasHasilSidang(item)
              .then((response) => {
                if (response.data.success) {
                  // Handle success if needed
                }
              })
              .catch((error) => {
                // Handle error if needed
              });
            promises.push(updatePromise);
          }

          if (item.file_type == "file_pdf" || item.file_type == "file_img") {
            if (this.file[item.title_slug] != null) {
              let uploadPromise = uploadFileBerkasHasilSidang(
                this.file[item.title_slug],
                "user",
                (event) => {
                  this.progress = Math.round((100 * event.loaded) / event.total);
                }
              )
                .then((response) => {
                  if (response.data.success) {
                    item.hasil_sidang_uuid = this.$route.params.uuid;
                    item.file_id = response.data.data.id;
                    return updateBerkasHasilSidang(item);
                  }
                })
                .then((response) => {
                  if (response && response.data.success) {
                    // Handle success if needed
                  }
                })
                .catch((error) => {
                  // Handle error if needed
                });
              promises.push(uploadPromise);
            }
          }
        });

        Promise.all(promises)
          .then(() => {
            var data = {
              hasil_sidang_uuid: this.$route.params.uuid,
            };
            postNotifUpdateBerkas(data)
              .then((response) => {
                this.showLoading = 0;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Hasil Sidang",
                    icon: "EditIcon",
                    variant: "success",
                    text: "Data berhasil disimpan.",
                  },
                });
              })
              .catch((error) => {
                this.showLoading = 0;
              });
            setTimeout(() => {
              window.location.reload();
            }, 3000);
            this.showModal = 0;
            this.$bvModal.hide("bv-modal-konfirmasi-berkas");
          })
          .catch((error) => {
            this.showLoading = 0;
            // Handle error if needed
          });
      }
    },
    checkPayload() {
      if (this.counterPayload == this.successPayload) {
        this.showModal = 0;
        location.reload();
      }
    },
    async lihatFile(file) {
      try {
        if (typeof file === "object") {
          // kode yang dijalankan jika file adalah object
          file = file.nama;
        }
        const resp = await downloadBerkasHasilSidang(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (
          type_file === ".png" ||
          type_file === ".PNG" ||
          type_file === ".jpg" ||
          type_file === ".JPG" ||
          type_file === ".jpeg" ||
          type_file === ".JPEG"
        ) {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Hasil Sidang",
            icon: "EditIcon",
            variant: "danger",
            text: "File tidak ditemukan",
          },
          duration: 5000,
        });
      }
    },
    permintaanPerubahanNilai(params) {
      if (params == "konfirmasi") {
        this.$bvModal.show("bv-modal-konfirmasi-perubahan-nilai");
      } else if (params == "ya") {
        this.perubahan_nilai.hasil_sidang_id = this.$route.params.uuid;
        postPermintaanPerubahanNilai(this.perubahan_nilai)
          .then((response) => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });
              this.$bvModal.hide("bv-modal-konfirmasi-perubahan-nilai");
            } else {
              this.$bvModal.hide("bv-modal-konfirmasi-perubahan-nilai");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    tandaiSelesai(params) {
      if (params == "konfirmasi") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        this.$bvModal.show("bv-modal-konfirmasi-selesai");
      } else if (params == "ya") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        this.selesai.hasil_sidang_id = this.$route.params.uuid;
        postTandaiSelesai(this.selesai)
          .then((response) => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });
              this.showModal = 0;
              this.$bvModal.hide("bv-modal-konfirmasi-selesai");
              this.$router.push({ name: "hasil-sidang" });
            } else {
              this.$bvModal.hide("bv-modal-konfirmasi-selesai");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
              this.showModal = 0;
            }
          })
          .catch((error) => {
            this.showModal = 0;
          });
      }
    },
    simpanStatusHasilSidang(params) {
      if (params == "konfirmasi") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        this.$bvModal.show("bv-modal-konfirmasi-nilai-akhir");
      } else if (params == "ya") {
        this.$bvModal.show("modal-center-loading");
        this.showModal = 1;
        this.status_hasil_sidang.uuid = this.$route.params.uuid;
        this.status_hasil_sidang.status_hasil_sidang_id = this.mainData.status_hasil_sidang_id;
        this.status_hasil_sidang.tanggal_awal_revisi = this.mainData.tanggal_awal_revisi;
        this.status_hasil_sidang.tanggal_akhir_revisi = this.mainData.tanggal_akhir_revisi;
        updateStatusHasilSidang(this.status_hasil_sidang)
          .then((response) => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });
              this.showModal = 0;
              this.$bvModal.hide("bv-modal-konfirmasi-nilai-akhir");
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
              this.showModal = 0;
            }
          })
          .catch((error) => {
            this.showModal = 0;
          });
      }
    },
    simpanDataCatatan(mark) {
      this.catatan.uuid = this.$route.params.uuid;
      updateCatatanHasilSidang(this.catatan)
        .then((response) => {
          if (response.data.success === true) {
            if (mark == "onchange") {
              console.log("update success");
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Hasil Sidang",
                icon: "EditIcon",
                variant: "danger",
                text: response.data.message,
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },
    simpanBeritaAcara(params) {
      if (params == "konfirmasi") {
        this.$bvModal.show("bv-modal-konfirmasi-berita");
      } else if (params == "ya") {
        updateBeritaAcara(this.mainData.absensi)
          .then((response) => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });

              var data = {
                hasil_sidang_id: this.$route.params.uuid,
              };
              buildBeritaAcara(data).then((response) => {
                if (response.data.success == true) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Hasil Sidang",
                      icon: "EditIcon",
                      variant: "success",
                      text: "File berhasil dibuat",
                    },
                  });
                }
              });
              this.$bvModal.hide("bv-modal-konfirmasi-berita");
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    simpanDataJawaban(params) {
      if (params == "konfirmasi") {
        this.$bvModal.show("bv-modal-konfirmasi");
      } else if (params == "ya") {
        this.jawaban_penilaian = this.mainData;
        updateJawabanPenilaianHasilSidang(this.jawaban_penilaian)
          .then((response) => {
            if (response.data.success === true) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "success",
                  text: "Data berhasil disimpan",
                },
              });
              this.$bvModal.hide("bv-modal-konfirmasi");
              setTimeout(() => {
                location.reload();
              }, 2000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Hasil Sidang",
                  icon: "EditIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    simpanDataJawabanRealtime(params) {
      this.jawaban_penilaian = this.mainData;
      updateJawabanPenilaianHasilSidang(this.jawaban_penilaian)
        .then((response) => {
          if (response.data.success === true) {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: 'Hasil Sidang',
            //     icon: 'EditIcon',
            //     variant: 'success',
            //     text: 'Data berhasil disimpan',
            //   },
            // })
            // this.$bvModal.hide('bv-modal-konfirmasi')
            // setTimeout(() => {
            //   location.reload()
            // }, 2000);
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Hasil Sidang",
                icon: "EditIcon",
                variant: "danger",
                text: response.data.message,
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },
    DetailHasilSidang() {
      getDetailHasilSidang(this.$route.params.uuid)
        .then((response) => {
          if (response.data.success === true) {
            return response.data.data;
          }
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    this.$bvModal.show("modal-center-loading");
    var success_check = [];
    getDetailHasilSidang(this.$route.params.uuid)
      .then((response) => {
        if (response.data.success === true) {
          success_check.push("success");
          this.completeCheck(success_check);
          this.mainData = response.data.data;
          if (
            this.mainData.tanggal_awal_revisi == null ||
            this.mainData.tanggal_awal_revisi == undefined
          ) {
            const currentDate = new Date();
            const formattedDate =
              currentDate.getFullYear() +
              "-" +
              ("0" + (currentDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + currentDate.getDate()).slice(-2);
            this.mainData.tanggal_awal_revisi = formattedDate;
          }

          if (response.data.data.dosen_penguji.length > 0) {
            response.data.data.dosen_penguji.forEach((element) => {
              this.dosenPengujiOption.options.push({
                label: element.nama,
                value: element.uuid,
              });
            });
          }
          if (response.data.data.catatan) {
            this.catatan = response.data.data.catatan;
          }
        }
      })
      .catch((error) => console.log(error));

    getStatusHasilSidang()
      .then((response) => {
        if (response.data.length > 0) {
          success_check.push("success");
          this.completeCheck(success_check);
          response.data.forEach((element) => {
            this.statusHasilSidangOption.options.push({
              label: element.nama,
              value: element.uuid,
            });
          });
        }
      })
      .catch((error) => console.log(error));
  },
};
</script>
